import { mainClient } from 'boot/axios'
import { IPortalUser, ILoginData, IMeta } from 'src/common/interfaces/index.js'

const IResponse = { meta: IMeta, data: { token: '', portal_user: IPortalUser, login_data: ILoginData } }
const IAuthRecoveryResponse = { meta: IMeta, data: { message: '' } }
const IEmailVerificationArgs = {
  email: '',
  redirect_url: '',
  first_name: '',
  surname: '',
  business_name: '',
  license_code: '',
}

export const auth = {
  /**
   * @param {{email: string; password: string}} filter
   * @return {Promise<IResponse>}
   */
  login(filter, signal) {
    return mainClient.post('auth/login', { filter }, { signal })
  },

  /**
   * @param {IEmailVerificationArgs} data
   * @return {Promise<IResponse>}
   */
  emailVerification(data, signal) {
    return mainClient.post('business/registration/part1', { data }, { signal })
  },

  /**
   * @param {{activation_token: string, password: string}} data
   * @return {Promise<IResponse>}
   */
  verifyInsert(data, signal) {
    return mainClient.post('business/registration/part2', { data }, { signal })
  },

  /**
   * @param {{email: string; redirect_url: string}} data
   * @return {Promise<IResponse>}
   */
  resendActivationEmail(filter, signal) {
    return mainClient.post('business/registration/resend-email', { filter }, { signal })
  },

  /**
   * @param {{email: string}} filter
   * @return {Promise<IAuthRecoveryResponse>}
   */
  forgottenPassword(filter, signal) {
    return mainClient.post('auth/forgotten-password', { filter }, { signal })
  },

  /**
   * @param {{filter: {token: string}; data: {password: string}}} payload
   * @return {Promise<IAuthRecoveryResponse>}
   */
  resetPassword(payload, signal) {
    return mainClient.post('auth/reset-password', payload, { signal })
  },
}
